/** Detects handheld devices without depending on the browser viewport size. */
export const isMobileOrTabletDevice = (): boolean => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent;
  const isHandheldUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
      userAgent,
    );

  // iPadOS can identify itself as macOS while still exposing touch points.
  const isIPadOS =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  return isHandheldUserAgent || isIPadOS;
};
